namespace advisorop.components.advisor {
    
    export class PopHhrRtgController {
        // bindings
        account: domains.IAccount;
        household: domains.IHousehold;

        // bindings inherited from modal
        modalInstance: any; //angular.ui.bootstrap.IModalServiceInstance

        static $inject = ["advisorService", "generalService", "$scope"];
        constructor(
            private advisorService: advisorop.services.AdvisorService,
            private generalService: advisorop.services.GeneralService,
            private $scope: ng.IScope
        ) {
        }

        isRIAAccount(): boolean {
            return true;
        }


        
        // default modal methods
        ok = () => {
            //console.log("PopHhr ok() function fired...");
            //console.log("This scope:", this.$scope);
            const $resolve = this.$scope.$parent.$resolve;

            const modal = (this.$scope.$parent.$uibModalInstance as angular.ui.bootstrap.IModalServiceInstance);

            modal.close(this.account);
        };

        cancel = () => {
            this.$scope.$parent.$uibModalInstance.dismiss();
        };

        
        // overrides
        $onInit(): void {
            // initialise modal
            const $resolve = this.$scope.$parent.$resolve;

            this.household = $resolve.household;

            var promAcc = $resolve.account;
            
            //console.log("Resolved account: ", promAcc);

            this.account = $resolve.account;
        }
    }

    class PopHhrRtg implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
            };
            this.controller = PopHhrRtgController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/advisor-module/components/pop-hhr-rtg.html";
        }
        
    }
    angular.module(Constants.APP).component("popHhrRtg", new PopHhrRtg());
}